import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import { COLORS, FONTS } from "../../constant";


const useStyles = CreateResponsiveStyle({
    checkBoxViewStyle: { marginTop: "10%" },
    selectViewStyle: { width: '40%',marginHorizontal:10, marginTop: 10 },

    contentViewStyle: {
      flexDirection: "row",
      marginHorizontal: 30 
    },
    infoWrapper:{
      width:300,
      flexDirection:'row', 
      backgroundColor:COLORS.blue550,
      borderRadius:10,
      padding:15,
      marginTop:12
    },
    disputeWrapper:{
      width:"50%"
    },
    textInputStyle: {
        width: 'auto',
        height: 90,
        borderRadius: 9,
        backgroundColor: "#ffffff",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#b9b9b9",
        paddingVertical: 10
        // marginTop: 10,
      },
    disputeText:{
      fontFamily:FONTS.InterBold,
      fontSize:12,
      color:COLORS.black200,
    },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      borderRadius: 10,
    },
    uploadImageWidget:{flexDirection:"row",},
    uploadImageTitle:{width:'100%'},
  }, {
    [DEVICE_SIZES.XS]: {
      contentViewStyle: {
        flexDirection: "column",
        marginHorizontal: 10
      },
      checkBoxViewStyle: { marginTop: "40%" },
      disputeWrapper:{
        marginTop:60
      },
      selectViewStyle: { width: '50%',marginHorizontal:20, marginTop: 10 },
    }
  });
  export default useStyles